'use client'

import { useState, useEffect } from 'react'

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!getCookie('cookie_consent')) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- reads document.cookie after mount to avoid an SSR hydration mismatch
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  const handleAcceptAll = () => {
    setCookie('cookie_consent', 'all', 365)
    setVisible(false)
  }

  const handleNecessaryOnly = () => {
    setCookie('cookie_consent', 'necessary', 365)
    setVisible(false)
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9998] border-t border-gray-200 bg-white p-4 shadow-lg"
      data-testid="cookie-consent"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-4 sm:flex-row">
        <p className="flex-1 text-sm text-gray-600">
          We use cookies for authentication, analytics, and site functionality. We never sell or share your personal information. By continuing to use this site, you consent to our use of cookies.
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleNecessaryOnly}
            className="border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            data-testid="cookie-necessary"
          >
            Necessary Only
          </button>
          <button
            onClick={handleAcceptAll}
            className="bg-brand-700 px-4 py-2 text-sm font-medium text-white hover:bg-brand-800 transition-colors"
            data-testid="cookie-accept-all"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  )
}
